import React from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../images/back.svg';
import './mytasks.scss';

function MyTasks() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const details = useLocation().state;
  const isUS = useSelector((state) => state.auth.marketerDetails.category === 'us_agent');

  useEffect(() => {
    if (pathname === '/my-tasks' || pathname === '/my-tasks/') {
      navigate('/my-tasks/list', {
        replace: true,
      });
    }
  }, [navigate, pathname]);

  return (
    <>
      <main className="mytasks">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div className="selectors">
            <NavLink to="/my-tasks/list">List</NavLink>
            {/* <NavLink to="/my-tasks/board">Board</NavLink> */}
            {isUS && <NavLink to="/my-tasks/calendar">Calendar</NavLink>}
          </div>
          {details && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <Back onClick={() => navigate(-1)} style={{ cursor: 'pointer' }} />
              <div>
                <h2 style={{ margin: 0 }}>{`${details?.branch} `}</h2>
                <p>{`${details?.address}, ${details?.state}`}</p>
              </div>
            </div>
          )}
        </div>
        <Outlet />
      </main>
    </>
  );
}

export default MyTasks;
